import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "MDM Dashboard", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = { class: "mdm-white-panel" }
const _hoisted_4 = { class: "mdm-white-panel" }
const _hoisted_5 = { class: "mdm-white-panel" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = { class: "mdm-white-panel" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DodoRow = _resolveComponent("DodoRow")!
  const _component_PrimeColumn = _resolveComponent("PrimeColumn")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _hoisted_2,
    _createVNode(_component_DodoRow, { gap: "s" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.stats.countMdmDevice) + " Devices", 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.stats.countSwitchDevice) + " Switch devices", 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.stats.countPolicy) + " Policies", 1)
        ])
      ]),
      _: 1
    }),
    _hoisted_6,
    _createVNode(_component_DodoRow, { gap: "s" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_7, [
          (_ctx.policyTotal)
            ? (_openBlock(), _createBlock(_component_DataTable, {
                key: 0,
                value: _ctx.policyTotal,
                "responsive-layout": "scroll"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_PrimeColumn, {
                    field: "name",
                    header: "Name",
                    sortable: true
                  }),
                  _createVNode(_component_PrimeColumn, {
                    field: "active",
                    header: "Active this month",
                    sortable: true
                  }),
                  _createVNode(_component_PrimeColumn, {
                    field: "total",
                    header: "Total",
                    sortable: true
                  })
                ]),
                _: 1
              }, 8, ["value"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    })
  ]))
}